'use es6';

import Routes from 'ContentUtils/Routes';
import { buildOnLoadFeedbackClientCallback } from 'EmailData/feedback/actions';
import { fetchPortalSettings } from 'EmailData/portalSettings/actions';
import { VISIBLE_SURVEYS_EVAL_MAP } from 'EmailData/selectors/feedbackClient';
import { getHasPermissionsToLoadDashboard } from 'EmailData/selectors/user';
import router from 'EmailData/utils/history';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import AppRoutes from 'email-management-lib/refactor/components/app/AppRoutes';
import ProhibitedDashboard from 'email-management-lib/refactor/components/app/ProhibitedDashboard';
import { VISIBLE_SURVEYS } from 'email-management-lib/refactor/constants/feedback';
import { MAILCHIMP_IMPORT_STATUS } from 'email-management-lib/refactor/constants/manage/onboarding';
import { getMailchimpImportStatus } from 'email-management-lib/refactor/selectors/manage/onboarding';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import UserReferenceResolver from 'reference-resolvers/resolvers/UserReferenceResolver';
import SuspensionBanners from 'ui-suspension-banners-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  const portalSettings = state.get('portalSettings').settings;
  return {
    canAccessEmail: getHasPermissionsToLoadDashboard(state),
    shouldFetchPortalSettingsHere: portalSettings.length === 0,
    mailchimpImportStatus: getMailchimpImportStatus(state)
  };
};
const mapDispatchToProps = {
  onLoadFeedbackClient: buildOnLoadFeedbackClientCallback({
    visibleSurveys: VISIBLE_SURVEYS,
    visibleSurveysEvalMap: VISIBLE_SURVEYS_EVAL_MAP
  }),
  fetchPortalSettings
};
class AppContainer extends Component {
  componentDidMount() {
    router.configure(this.props.history);
    if (this.props.shouldFetchPortalSettingsHere) {
      this.props.fetchPortalSettings();
    }
  }
  componentWillUnmount() {
    if (this.unsubscribeHistory) this.unsubscribeHistory();
  }
  componentDidUpdate() {
    if (this.props.mailchimpImportStatus === MAILCHIMP_IMPORT_STATUS.COMPLETED) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link: props => /*#__PURE__*/_jsx(Link, {
              external: true,
              href: Routes.lists(),
              children: props.children
            })
          },
          message: "email-management.onboardingChecklist.MAILCHIMP_IMPORT.successBody_jsx"
        }),
        titleText: I18n.text('email-management.onboardingChecklist.MAILCHIMP_IMPORT.successTitle'),
        timeout: 10000,
        type: 'success'
      });
    }
  }
  render() {
    return this.props.canAccessEmail ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SuspensionBanners, {
        scope: "email-trusted",
        source: "EMAIL"
      }), /*#__PURE__*/_jsx(AppRoutes, {
        onLoadFeedbackClient: this.props.onLoadFeedbackClient
      })]
    }) : /*#__PURE__*/_jsx(ProhibitedDashboard, {});
  }
}
AppContainer.propTypes = {
  canAccessEmail: PropTypes.bool,
  fetchPortalSettings: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  mailchimpImportStatus: PropTypes.string,
  onLoadFeedbackClient: PropTypes.func.isRequired,
  shouldFetchPortalSettingsHere: PropTypes.bool.isRequired
};
const resolvers = {
  [USER]: UserReferenceResolver
};
const ResolvedAppContainer = ProvideReferenceResolvers(resolvers)(AppContainer);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResolvedAppContainer));